<template>
  <ui-dialog show max-width="542px" @input="closeDialog">
    <template #header>
      <h3>{{ $t(`message.apple.configureAlert.title`) }}</h3>
    </template>
    <div class="content">
      <div>
        {{ $t(`message.apple.configureAlert.description`) }}
      </div>
    </div>
    <template #actions>
      <ui-button color="primary" outlined @click="closeDialog">
        {{ $t("message.common.cancel") }}
      </ui-button>
      <ui-button color="primary" @click="goToAppleAccount">
        {{ $t(`message.apple.configureAlert.confirmLabel`) }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
export default {
  name: "AppleNoAccountDialog",
  methods: {
    goToAppleAccount() {
      this.$router.push({ name: "profile-apple-accounts" });
    },
    closeDialog() {
      this.$emit("close");
    }
  }
};
</script>
<style lang="scss" scoped>
.content {
  color: $grey-darker;
}
</style>
